import styled from "styled-components";

export const EditorToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;

  margin-bottom: 1px;
  padding: 4px;
  vertical-align: middle;
  overflow: auto;

  border-radius: 4px 4px 0 0;
  border: 1px solid ${({ theme }) => theme.lexicalEditor.borderColor};
  border-bottom: transparent;

  .block-controls {
    align-items: center;
    display: flex;
    gap: 0.5rem;
  }

  .block-controls button:hover {
    background-color: #efefef;
  }

  .block-controls button:focus-visible {
    border-color: blue;
  }

  .block-controls span.block-type {
    background-size: contain;
    display: block;
    width: 10.5rem;
    height: 10.5rem;
    margin: 2px;
  }
`;
